<template>
  <div>
    <div class="btn-wrapper mb-10 mr-20 move-right">
      <router-link to="/admin/hrm/leave/all" class="btn-back">
        <span>Back</span>
      </router-link>
    </div>
    <el-form
      :model="editLeaveForm"
      :rules="rules"
      ref="editLeaveForm"
      class="form white-bg"
      label-position="left"
      label-width="160px"
      v-loading="loading"
    >
      <h3 class="text-gray bold mt-0 mb-40">Edit Leave</h3>
      <div class="mt-20">
        <el-form-item prop="employee_id" label="Employee Name">
          <el-select
            v-model="editLeaveForm.employee_id"
            placeholder="Select"
            name="employees"
            filterable
            remote
            :remote-method="searchEmployees"
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="mt-20">
        <el-form-item prop="leave_id" label="Leave Type">
          <el-select
            v-model="editLeaveForm.leave_id"
            placeholder="Select Leave Type"
            name="leave_type_id"
          >
            <el-option
              v-for="item in employeeLeave"
              :key="item.id"
              :label="item.leave_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="mt-20">
        <el-form-item prop="date" label="Leave Date">
          <el-date-picker
            v-model="editLeaveForm.date"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </div>
      <div class="mt-20">
        <el-form-item prop="note" label="Reason">
          <el-input
            type="textarea"
            :rows="5"
            placeholder
            v-model="editLeaveForm.note"
          ></el-input>
        </el-form-item>
      </div>
      <div class="mt-20">
        <el-form-item prop="handover_to" label="Relief Staff">
          <el-select
            v-model="editLeaveForm.handover_to"
            placeholder="Employee name"
            filterable
            remote
            :remote-method="searchEmployees"
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="">
        <div class="btn-wrapper mt-20 sec-span">
          <el-button
            class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15"
            :loading="loading"
            @click.prevent="update()"
            >Save Changes</el-button
          >
          <button
            class="btn btn-light-gray no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click.prevent="$router.go(-1)"
          >
            Cancel
          </button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import debounce from "lodash.debounce";

const { mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  data() {
    return {
      editLeaveForm: {
        employee_id: null,
        start_date: null,
        end_date: null,
        handover_to: null,
        leave_id: null,
        note: "",
        date: [],
      },
      employee_id: null,
      employeeIds: null,
      handover_to: null,
      reliefIds: null,
      employees: [],
      employeeLeave: [],
      loading: false,
      rules: {
        employee_id: [
          {
            required: true,
            message: "Please input employee name",
            trigger: "blur",
          },
        ],
        start_date: [
          { required: true, message: "Please start date ", trigger: "blur" },
        ],
        end_date: [
          {
            required: true,
            message: "Please select end date ",
            trigger: "blur",
          },
        ],
        date: [
          { required: true, message: "Please select date ", trigger: "blur" },
        ],
        leave_id: [
          {
            required: true,
            message: "Please select leave type ",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.findLeaveById(id);
    }
  },
  methods: {
    ...mapActions(["getLeaveById", "updateLeave"]),
    findLeaveById(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/hrm/leave/getLeaveById", id)
        .then(response => {
          this.loading = false;
          const {
            id,
            employee_id,
            employee_name,
            start_date,
            end_date,
            handover_to,
            leave_id,
            note,
            relief,
          } = response.data;
          this.employeeIds = employee_id;
          this.reliefIds = handover_to;
          const db = [];
          db.push(start_date, end_date);
          this.fetchLeaveByEmployee(employee_id);
          this.editLeaveForm = {
            ...this.editLeaveForm,
            id,
            employee_id: employee_name,
            date: db,
            handover_to: relief,
            leave_id,
            note,
          };
        })
        .catch(() => {
          this.loading = false;
        });
    },
    update() {
      this.$refs[`editLeaveForm`].validate(valid => {
        if (valid) {
          const id = this.$route.params.id;
          this.loading = true;
          const formData = {
            employee_id:
              typeof this.editLeaveForm.employee_id === "string"
                ? this.employeeIds
                : this.editLeaveForm.employee_id,
            start_date: this.editLeaveForm.date[0],
            end_date: this.editLeaveForm.date[1],
            handover_to:
              typeof this.editLeaveForm.handover_to === "string"
                ? this.reliefIds
                : this.editLeaveForm.handover_to,
            leave_type_id: this.editLeaveForm.leave_id,
            note: this.editLeaveForm.note,
          };
          this.$store
            .dispatch("admin/hrm/leave/updateLeave", {
              data: formData,
              id,
            })
            .then(() => {
              this.loading = false;
              this.$router.push({ path: "/admin/hrm/leave/all" });
            })
            .catch(error => {
              this.loading = false;
              this.$notification.error(error.message);
            });
        }
      });
    },

    searchEmployees: debounce(function(searchQuery) {
      this.$store
        .dispatch("searchEmployees", searchQuery)
        .then(response => {
          this.employees = response;
        })
        .catch(() => {});
    }, 500),
    fetchLeaveByEmployee(employee_id) {
      this.$store
        .dispatch("admin/hrm/leave/getLeaveByEmployee", employee_id)
        .then(response => {
          this.employeeLeave = response.data;
        })
        .catch(error => {
          this.$notification.error(error.message);
        });
    },
  },
};
</script>
<style scoped>
.el-range-editor.el-input__inner {
  width: 100% !important;
  border: 1px solid #888 !important;
}
</style>
